"use client";

import Icon, {ICON_ANIMATE} from "@/components/library/Icon";
import {getExecutionState} from "../toolCallUtils";

export default function StepStatusIcon({
   completed,
   failed,
}: Readonly<{completed: boolean; failed: boolean}>) {
   const state = getExecutionState(failed, completed);

   if (state === "running") {
      return (
         <Icon
            icon="spinner"
            animate={ICON_ANIMATE.SPIN}
            className="h-2.5 w-2.5 text-gpt-accent"
         />
      );
   }
   if (state === "failed") {
      return <Icon icon="triangle-exclamation" className="h-2.5 w-2.5 text-destructive" />;
   }
   return <span className="h-1.5 w-1.5 rounded-full bg-300" />;
}
